import React from 'react';
import { Routes, Route } from "react-router-dom";

import Home from "./home"
import NotFound from "./not-found";


function MainApp() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route path="*" element={<NotFound />} />
  </Routes>
  );
}

export default MainApp;
